export const APPWRAPPER_BACKGROUNDS = {
  darkColor: "#152872",
  lightColor: "#0862acd1",
};

export const LOCAL_STORAGE_TOKEN = "auth-token";
